import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, LIST_MARGIN_HORIZONTAL, TYPOGRAPHY } from '@/styles';
import { formatCurrency } from '@/utils/money';
import { OrderSummary_PromotionFieldsFragment } from '@/types';
import { StyleProp, Text, View, ViewStyle } from 'react-native';

interface Props {
  calculatedDiscountInMicros: number;
  currencyCode: string | null;
  promotion: OrderSummary_PromotionFieldsFragment;
  style?: StyleProp<ViewStyle>;
}

export const VolumePromotionOrderSummaryBadge: React.FC<Props> = ({
  calculatedDiscountInMicros,
  currencyCode,
  promotion,
  style,
}) => {
  const [styles] = useStyles();

  return (
    <View style={[styles.base, style, styles.badge]}>
      <View style={styles.contentContainer}>
        <Text
          ellipsizeMode="tail"
          numberOfLines={2}
          style={[TYPOGRAPHY.medium, styles.labelText]}
        >
          {promotion.marketing_text}
        </Text>
        <View style={styles.discountContainer}>
          <Text style={[TYPOGRAPHY.medium, styles.discountText]}>
            {calculatedDiscountInMicros
              ? formatCurrency(-1 * calculatedDiscountInMicros, currencyCode)
              : null}
          </Text>
        </View>
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  badge: {
    borderRadius: 4,
    marginHorizontal: LIST_MARGIN_HORIZONTAL,
    marginVertical: 4,
    padding: 8,
  },
  base: {
    backgroundColor: theme.sk.color.bg.highlight.secondary,
    flex: 1,
    padding: 16,
  },
  contentContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  discountContainer: {
    alignItems: 'flex-end',
    alignSelf: 'flex-start',
    flexShrink: 0,
  },
  discountText: {
    ...FONTS.primary,
    color: theme.sk.color.text.success,
  },
  labelText: {
    ...FONTS.primarySemiBold,
    color: theme.sk.color.text.success,
    flexGrow: 1,
    flexShrink: 1,
  },
}));
